export default __webpack_public_path__ + "static/media/limb_cube@2x.9a14c72b.jpg";